'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = iffun;
/**
 * @description iffun it simple function which can be used to write better readable conditional statement with react jsx
 *
 * @example
 * iffun(this.state.loading === true, <Loader>, ()=> {return <App/>;})
 */

/**
 *
 * @param {*} statement
 * @param {*} firstF
 * @param {*} secondF
 */
function iffun(statement, firstF, secondF) {
  if (statement === true) {
    if (typeof firstF === 'function') {
      return firstF();
    } else {
      return firstF;
    }
  } else {
    if (typeof secondF === 'function') {
      return secondF();
    } else {
      return secondF;
    }
  }
}

//# sourceMappingURL=iffun.js.map